import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCustomPageTitle } from '../../hooks/usePageTitle';
import LoginForm from '../../components/auth/LoginForm';

const Login = () => {
  const location = useLocation();
  useCustomPageTitle('Connexion');
  const message = location.state?.message;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 className="mt-6 text-center text-xl font-bold text-gray-900">
          Connexion
        </h2>
        {message && (
          <div className="mt-4 p-4 bg-blue-50 text-blue-700 rounded-lg text-center">
            {message}
          </div>
        )}
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <LoginForm />
          <div className="mt-6 text-center">
            <Link
              to="/register"
              className="text-sm text-blue-600 hover:text-blue-500"
            >
              Pas encore de compte ? S'inscrire
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;